import React from "react";
import { useFormData } from "../../contexts/FormDataContext";
import { useLanguage } from "../../contexts";
import CustomSelect from "../CustomSelect";
import MultipleUploadStrip from "../MultipleUploadStrip";

export default function WorkExperienceSection() {
  const {
    formData,
    documentVault,
    handleChange,
    addEmploymentCertificate,
    removeEmploymentCertificate,
  } = useFormData();
  const { t } = useLanguage();

  const workExperienceOptions = Array.from({ length: 11 }, (_, index) => ({
    value: String(index),
    label: String(index),
  }));

  return (
    <div className="space-y-6">
      <CustomSelect
        label={t("sections.workExperience.years")}
        value={
          formData.workExperience === ""
            ? ""
            : String(formData.workExperience)
        }
        onChange={(value) => {
          if (value === "select") {
            handleChange("workExperience", "");
            return;
          }
          handleChange("workExperience", Number(value));
        }}
        options={workExperienceOptions}
        required={true}
      />

      <MultipleUploadStrip
        label={t("sections.workExperience.certificates")}
        files={formData.employmentCertificates}
        accept=".pdf,.doc,.docx,.odt"
        onAddFile={addEmploymentCertificate}
        onDeleteFile={removeEmploymentCertificate}
        existingOptions={documentVault?.employment_certificate}
        required={true}
      />
    </div>
  );
}